module.exports = __webpack_public_path__ + "img/performance-test-icon3.41882c32.png";